import { createStyles } from '@material-ui/core/styles';
export const styles =  createStyles({
  autocomplete: { width: '100%' },
  label: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      right: 0,
      bottom: 0,
      color:'black'
    },
 text:{
     color:'gray'
    }
})